import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/authentication/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'register',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/authentication/register/register.component').then((m) => m.RegisterComponent),
  },
  {
    path: 'verify-email',
    loadComponent: () =>
      import('./features/authentication/verify-email/verify-email.component').then(
        (m) => m.VerifyEmailComponent,
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/authentication/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent,
      ),
  },
  {
    path: 'accept-invite',
    loadComponent: () =>
      import('./features/authentication/accept-invite/accept-invite.component').then(
        (m) => m.AcceptInviteComponent,
      ),
  },
  {
    path: 'onboarding',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/family/onboarding/onboarding.component').then((m) => m.OnboardingComponent),
  },
  {
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/shell-layout.component').then((m) => m.ShellLayoutComponent),
    children: [
      {
        path: 'parent/:familyId',
        loadComponent: () =>
          import('./features/dashboard/parent/parent-dashboard.component').then(
            (m) => m.ParentDashboardComponent,
          ),
      },
      {
        path: 'student/:studentId',
        loadComponent: () =>
          import('./features/dashboard/student/student-dashboard.component').then(
            (m) => m.StudentDashboardComponent,
          ),
      },
      {
        path: 'grandparent/:familyId',
        loadComponent: () =>
          import('./features/dashboard/grandparent/grandparent-dashboard.component').then(
            (m) => m.GrandparentDashboardComponent,
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
